<template>
  <div>
    <div class="modal fade show">
      <div
        class="modal-dialog modal-dialog-centered"
        :class="{ 'modal-sm': sm, 'modal-xl': xl }"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header" v-if="title || iconc">
            <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
            <i v-if="iconc" class="bx bx-x clickable" @click="emit('close')"></i>
          </div>
          <div class="modal-body" v-if="!hidebody || error">
            <slot />
            <div class="alert alert-danger" role="alert" v-if="error">
              <div class="alert-text">{{ error }}</div>
            </div>
          </div>
          <div class="modal-footer" v-if="btnc || btns || loading">
            <div id="spinner" v-if="loading" />
            <template v-else>
              <slot name="buttons"></slot>
              <button
                v-if="btnc"
                type="button"
                class="btn btn-secondary minw"
                data-dismiss="modal"
                @click="emit('close')"
              >
                {{ btnc }}
              </button>
              <button type="button" class="btn btn-primary minw" v-if="btns" @click="emit('save')">
                {{ btns }}
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title?: string
  btns?: string
  btnc?: string
  iconc?: boolean
  sm?: boolean
  xl?: boolean
  error?: string
  loading?: boolean
  hidebody?: boolean
}>()

const emit = defineEmits<{
  (e: 'save'): void
  (e: 'close'): void
}>()
</script>
